import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkOperations = ({ 
  selectedDocuments, 
  onBulkOperation, 
  onClearSelection 
}) => {
  const [selectedOperation, setSelectedOperation] = useState('');

  const operationOptions = [
    { value: '', label: 'Select bulk operation...' },
    { value: 'request-signature', label: 'Request Signatures' },
    { value: 'download', label: 'Download Documents' },
    { value: 'archive', label: 'Archive Documents' },
    { value: 'delete', label: 'Delete Documents' },
    { value: 'share', label: 'Share Documents' },
    { value: 'export', label: 'Export to PDF' }
  ];

  const handleExecuteOperation = () => {
    if (selectedOperation && selectedDocuments?.length > 0) {
      onBulkOperation(selectedOperation, selectedDocuments);
      setSelectedOperation('');
    }
  };

  if (selectedDocuments?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="font-medium text-foreground">
              {selectedDocuments?.length} document{selectedDocuments?.length !== 1 ? 's' : ''} selected
            </span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Select
              options={operationOptions}
              value={selectedOperation}
              onChange={setSelectedOperation}
              placeholder="Choose operation..."
              className="min-w-48"
            />
            
            <Button
              variant="default"
              onClick={handleExecuteOperation}
              disabled={!selectedOperation}
              iconName="Play"
              iconPosition="left"
            >
              Execute
            </Button>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconPosition="left"
          >
            Clear Selection
          </Button>
        </div>
      </div>
      {/* Quick Action Buttons */}
      <div className="flex items-center space-x-2 mt-4 pt-4 border-t border-border">
        <span className="text-sm text-muted-foreground">Quick actions:</span>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkOperation('request-signature', selectedDocuments)}
          iconName="PenTool"
          iconPosition="left"
        >
          Request Signatures
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkOperation('download', selectedDocuments)}
          iconName="Download"
          iconPosition="left"
        >
          Download
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkOperation('share', selectedDocuments)}
          iconName="Share"
          iconPosition="left"
        >
          Share
        </Button>
      </div>
    </div>
  );
};

export default BulkOperations;